import React from 'react';
export function RelatedLinkSection() {
  return <div className="text-center pt-8 border-t border-gray-200" data-id="element-2297">
      <a href="59m7/mikron-high-speed-3-5-axis-milling.html" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline font-bold text-xl" data-id="element-2298">
        Mikron 3 &amp; 5-Axis Milling
      </a>
    </div>;
}